<template>
  <div>
    <date-range-picker
      v-model="dateRange"
      time-picker
      :always-show-calendars="true"
      :max-date="minEndDateCom"
      :min-date="minDate"
      @update="update"
      :show-week-numbers="false"
      auto-apply
      :ranges="false"
      control-container-class="control-container"
    ></date-range-picker>
  </div>
</template>

<script>
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { mapGetters } from "vuex";

export default {
  components: { DateRangePicker },
  name: "DateComponent",
  data() {
    const initialStartDate = this.minDate || this.minStartDate;
    const initialEndDate = this.maxDate || this.maxEndDate;
    
    return {
      startdate: "",
      enddate: "",
      endIsBeforeStart: false,
      "max-date": "",
      "min-date": "",
      dateRange: {
        startDate: initialStartDate,
        endDate: initialEndDate,
      },
    };
  },
  props: {
    maxDate: {
      type: String,
      default: null,
    },
    minDate: {
      type: String,
      default: null,
    },
    // When true, do not prefill or emit initial period on mount
    noDefault: {
      type: Boolean,
      default: false,
    },
    // Increment this number to trigger a reset from parent
    resetSignal: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters(["profile"]),
    isValidStartDate() {
      return this.isValidDate(this.startdate);
    },
    isValidEndDate() {
      return this.isValidDate(this.enddate);
    },
    isStartDateBeforeEndDate() {
      return moment(this.startdate).isBefore(this.enddate);
    },
    period() {
      return (
        this.isValidStartDate &&
        this.isValidEndDate &&
        this.isStartDateBeforeEndDate
      );
    },
    maxEndDate() {
      return moment().format("YYYY-MM-DD");
    },
    minEndDateCom() {
      if (this.maxDate) {
        return this.maxDate;
      }
      const maxEndDateWithTime = new Date(this.maxEndDate);
      return maxEndDateWithTime.setHours(23, 59, 59, 999);
    },
    minStartDate() {
      if (this.minDate) {
        return this.minDate;
      }
      return moment().subtract(1, "days").format("YYYY-MM-DD");
    },
    ranges() {
      return [this.dateRange?.startDate, this.maxEndDate];
    },
    chartSettings() {
      return this.profile.company.chartDateTimeSettings;
    },
  },
  created() {
    if (this.noDefault) return;
    const minStartDateWithTime = new Date(this.minStartDate);
    minStartDateWithTime.setHours(0, 0, 0, 0);

    const maxEndDateWithTime = new Date(this.maxEndDate);
    maxEndDateWithTime.setHours(23, 59, 59, 999);
    if (this.chartSettings !== "transmissionStartDate") {
      this.dateRange = {
        startDate: minStartDateWithTime,
        endDate: maxEndDateWithTime,
      };
    }
    this.update({
      startDate:
        this.chartSettings !== "transmissionStartDate"
          ? minStartDateWithTime
          : undefined,
      endDate:
        this.chartSettings !== "transmissionStartDate"
          ? maxEndDateWithTime
          : undefined,
    });
  },
  methods: {
    isValidDate(dateString) {
      return moment(dateString, "YYYY-MM-DD", true).isValid();
    },
    handleDateChange() {
      this.endIsBeforeStart = !this.isStartDateBeforeEndDate;
    },
    dateFormat(classes, date) {
      if (!classes.disabled) {
        classes.disabled = date.getTime() < new Date();
      }
      return classes;
    },
    update({ endDate, startDate }) {
      let period = {
        startdate: startDate ? moment(startDate).format() : undefined,
        enddate: endDate ? moment(endDate).format() : undefined,
      };

      this.$emit("period", period);
    },
  },
  watch: {
    resetSignal() {
      // Reset date range and notify parent with undefined values
      this.dateRange = { startDate: null, endDate: null };
      this.$emit("period", { startdate: undefined, enddate: undefined });
    },
    period() {
      let period = {
        startdate: this.period ? moment(this.startdate).format() : "",
        enddate: this.period ? moment(this.enddate).format() : "",
      };

      this.$emit("period", period);
    },
    startdate: "handleDateChange",
    enddate: "handleDateChange",
  },
};
</script>

<style scoped>
.date-component {
  border-radius: 16px;
  border: 0.5px solid #b7c3cd;
  padding: 13px 0px 13px 13px;
  width: fit-content;
  background: white;
}
.dash {
  position: relative;
  /* left: -12px; */
  margin-right: 8px;
}

input {
  background: white !important;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
}

input[type="date"]::-moz-calendar-picker-indicator {
  display: none;
}

input[type="date"]::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}

/* .v-date-picker {
  display: flex;
  align-items: center;
  column-gap: 5px;
} */

  .control-container .vue-daterange-picker .reportrange-text {
  border-radius: 16px;
  border: 0.5px solid #b7c3cd;
  padding: 13px !important;
  width: fit-content;
  background: white;
  }
  
.control-container {
  display: flex;
  align-items: center;
  column-gap: 5px;
  cursor: pointer !important;
}

/* border: 1px solid #404a57;
    padding: 4px;
    border-radius: 6px; */
</style>
